import { render, staticRenderFns } from "./BaseTopicWithChildren.vue?vue&type=template&id=0be96fb2&"
import script from "./BaseTopicWithChildren.vue?vue&type=script&lang=js&"
export * from "./BaseTopicWithChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports